import { Box, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { userAtom } from '../state';

export default function ImpersonateBanner(): React.JSX.Element {
  const { t } = useTranslation(['common']);
  const {
    impersonateMode,
    first_name,
    last_name,
    email,
  } = useAtomValue(userAtom);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      { impersonateMode && (
        <Box
          sx={{
            alignItems: 'center',
            color: 'onError.main',
            backgroundColor: 'error.main',
            textAlign: 'center',
            py: 1.5,
          }}
        >
          <Typography>{`${t('common:impersonation_of')}: ${first_name} ${last_name} (${email})`}</Typography>
        </Box>
      )}
    </>
  );
}
